import $ from 'jquery'
import BScroll from 'better-scroll'
/**
 * 自动获取焦点
 * @type {{name: string, inserted: focus.inserted}}
 */
export const focus = {
  name: 'focus',
  inserted: function(el) {
    el.focus()
  }
}

/**
 * 修复ios12下，部分ios设备键盘弹出收回后，页面被顶起的问题
 */
export const fixIos12Input = {
  name: 'fixIos12Input',
  inserted: function(el) {
    el.addEventListener('blur', function() {
      el.dataset.timer = setTimeout(() => {
        $(window).scrollTop(99999999999)
      }, 100)
    })
  },
  unbind: function(el) {
    clearTimeout(el.dataset.timer)
  }
}

/**
 * better-scroll 替代滚动事件
 */
export const scroll = {
  name: 'scroll',
  bind(el, binding, vnode, oldVnode) {
    // better-scroll 默认配置
    const options = {
      scrollY: false,
      scrollX: true,
      click: true,
      bounceTime: 300,
      swipeBounceTime: 300
    }

    // 判断输入参数
    // const vtype = binding.value ? [].toString.call(binding.value) : undefined

    // 设置better-scroll属性的参数
    // let scrollOptions = vtype === '[object Object]' ? binding.value : options;
    const scrollOptions = { ...options, ...binding.value }

    // 阻止touchmove默认事件
    el.addEventListener('touchmove', event => {
      event.preventDefault()
    })

    // 使用vnode绑定better-scroll是为了让better-scroll对象能够夸状态传递，避免better-scroll重复建立
    vnode.scroll = new BScroll(el, scrollOptions)
  },
  update(el, binding, vnode, oldVnode) {
    // 将scroll绑定到新的vnode上
    vnode.scroll = oldVnode.scroll
  },
  unbind(el, binding, vnode, oldVnode) {
    // 解除绑定时要把better-scroll销毁
    vnode.scroll = oldVnode.scroll
    vnode.scroll.destroy()
    vnode.scroll = null
  }
}

export const imgLazyLoad = {
  name: 'imgLazyLoad',
  inserted(el, binding, vNode) {
    el.style.background = `url('http://static2.kaxiuyun.com/kxy/common/image-load.svg') center no-repeat`
    el.style.backgroundSize = `60px`
    function loadImg(el, binding) {
      if (!el.src) {
        el.src = binding.value
      }
    }

    const io = new IntersectionObserver(ioes => {
      ioes.forEach(v => {
        const el = v.target
        const intersectionRatio = v.intersectionRatio
        if (intersectionRatio > 0 && intersectionRatio <= 1) {
          console.log('开始加载')
          loadImg(el, binding)
        }
        // 图片加载成功 或 失败 则停止观察
        el.onload = el.onerror = () => {
          console.log('加载完成')
          io.unobserve(el)
        }
      })
    })

    io.observe(el)
  }
}
